import { Box, CircularProgress, useMediaQuery, useTheme } from "@mui/material";
import { OrganizationUserContext } from "contexts/Organization";
import { VaSettingsContext } from "contexts/VaSettings";
import { useContext, useEffect } from "react";
import { routes } from "schemas/routes";

import { PAGE_VISITED } from "constants/trackingProps";
import { isPage } from "utils/general";
import { trackEvent } from "utils/tracking";

import EmailBoost from "./EmailBoost";
import VAPreviewPage from "./PreviewPage";
import GeneralSettings from "./VASettings/GeneralSettings";

export default function VA() {
  // Contexts
  const theme = useTheme();
  const isMobileScreen = useMediaQuery(theme.breakpoints.down("md"));
  const { currentOrg, currentUser } = useContext(OrganizationUserContext);

  const { loadData, bulkSendSetting, fetchLoading, setFetchLoading } =
    useContext(VaSettingsContext);

  useEffect(() => {
    trackEvent(PAGE_VISITED);
    if (currentOrg?.isVaUser) {
      loadData();
    } else {
      setFetchLoading(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (
      typeof window === "undefined" ||
      !currentOrg?.id ||
      !currentOrg?.isVaUser ||
      !isPage(routes.virtualAssistant) ||
      isMobileScreen
    )
      return;

    // If we already init FreshChat, we just need to register the user name and email.
    if ((window as any).fcWidget) {
      const fcWidget = (window as any).fcWidget;
      registerUserNameAndEmail(fcWidget);
      return;
    }

    const script = document.createElement("script");
    script.src = "//in.fw-cdn.com/32587301/1436123.js";
    script.async = true;
    script.setAttribute("chat", "true");

    document.body.appendChild(script);
    const fcWidget = (window as any).fcWidget;
    registerUserNameAndEmail(fcWidget);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentOrg?.id]);

  const registerUserNameAndEmail = (fcWidget: any) => {
    if (!fcWidget) return;
    fcWidget.setExternalId(currentOrg?.id);
    fcWidget.user.setFirstName(currentUser?.name);
    fcWidget.user.setEmail(currentUser?.email);
  };

  if (fetchLoading) {
    return (
      <Box
        sx={{
          color: "#fff",
          zIndex: 9999,
          left: "50%",
          top: "50%",
          ml: "-20px",
          mt: "-20px",
          position: "absolute",
        }}
      >
        <CircularProgress />
      </Box>
    );
  }

  if (currentOrg?.isVaUser && bulkSendSetting) {
    return (
      <>
        <GeneralSettings />
        {!isMobileScreen && <EmailBoost />}
      </>
    );
  }

  return <VAPreviewPage />;
}
